import {defaultObjectMapData} from "../objects/defaults";

export const defaultTechMapData = {
  infrastructure: null,
  borders: null,
}
export default {
  techExcelFiles: null,
  techInfrastructure: [],
  techMapData: JSON.parse(JSON.stringify(defaultTechMapData)),
  forceTechMapCenter: null,
  techMapParams: null,
  techSelectedInfrastructure: null,
  techLoadingData: 0,
}



// WEBPACK FOOTER //
// ./src/store/technologies/defaults.js